import ThreadsSearchDialogBody from './ThreadsSearchDialogBody'
import { useThreadsSearchControls } from './useThreadsSearchControls'
import { useThreadsSearchListQuery } from './useThreadsSearchListQuery'
import { useThreadsSearchPreview } from './useThreadsSearchPreview'
import { activateSearchThreadWorkspace } from './activateSearchThreadWorkspace'
import { THREAD_WORKSPACE_SCOPE } from './threadWorkspaceScope'

export default function ThreadsSearchDialogSession({
  workspaceScope = THREAD_WORKSPACE_SCOPE.CURRENT,
  onSelectThread,
  onClose,
  onThreadMenuAction,
  onRenameThread,
}) {
  const controls = useThreadsSearchControls()
  const list = useThreadsSearchListQuery({
    workspaceScope,
    facet: controls.filter,
    q: controls.debouncedQ,
    enabled: true,
  })
  const preview = useThreadsSearchPreview({
    threads: list.threads,
    onSelectThread: (thread) => {
      activateSearchThreadWorkspace(thread)
      onSelectThread?.(thread)
    },
    onClose,
  })
  return (
    <ThreadsSearchDialogBody
      model={{ ...controls, filteredThreads: list.threads, ...preview }}
      threads={list.threads}
      loading={list.loading}
      open
      onThreadMenuAction={onThreadMenuAction}
      onRenameThread={onRenameThread}
    />
  )
}
